import React from 'react';

import CircularProgress from '@material-ui/core/CircularProgress';

const Loader = props => <CircularProgress {...props} />

export default Loader;



// WEBPACK FOOTER //
// ./src/components/base/Loader/Loader.js